import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { ShareEntityModel, TellAFriendModel } from "@insite/client-framework/Types/ApiModels";
import { RmaModel } from "@store/Types/ApiModels";

const emailsUrl = "/api/v1/email";
const emailSubscriptionUrl = "/email";
const rmaUrl = "/api/v1/girardin/rma/rmasubmit";

export interface TellAFriendApiParameter extends ApiParameter {
    tellAFriendModel: TellAFriendModel;
}

export interface SubscribeToListApiParameter extends ApiParameter {
    emailAddress: string;
}

export interface ShareEntityApiParameter extends ApiParameter {
    shareEntityModel: ShareEntityModel;
    url: string;
}

export interface ShareEntityGenerateFromWebpageApiParameter {
    shareEntityModel: ShareEntityModel;
    urlPathToLoadForAttachmentHtml: string;
}

export interface SubmitContactUsFormApiParameter extends ApiParameter {
    topic?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    state?: string;
    country?: string;
    company?: string;
    city?: string;
    // Store custom code - to site settings
    // emailTo?: string;
}

export interface SubmitNewAccountContactFormApiParameter extends ApiParameter {
    isBusiness?: string;
    fleetSize?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    state?: string;
    country?: string;
    company?: string;
    city?: string;
    // Store custom code - to site settings
    // emailTo?: string;
}

// Store custom code
export interface SubmitPdpInfoFormApiParameter extends ApiParameter {
    city?: string;
    state?: string;
    country?: string;
    postalCode?: string;
    erpNumber?: string;
    productTitle?: string;
    productUrl?: string;
    productImage?: string;
}

// Store custom code
export interface RmaApiParameter extends ApiParameter {
    rmaModel: RmaModel;
}

// Store custom code
export function sendRmaRequestSubmit(parameter: RmaApiParameter) {
    return post<RmaModel>(`${rmaUrl}`, parameter.rmaModel);
}

export function tellAFriend(parameter: TellAFriendApiParameter) {
    return post<TellAFriendModel>(`${emailsUrl}/tellafriend`, parameter.tellAFriendModel);
}

export function shareEntity(parameter: ShareEntityApiParameter) {
    return post<ShareEntityModel>(parameter.url, parameter.shareEntityModel);
}

export function shareEntityGenerateFromWebpage(parameter: ShareEntityGenerateFromWebpageApiParameter) {
    return post<ShareEntityGenerateFromWebpageApiParameter, ShareEntityModel>("/.spire/shareEntity", parameter);
}

export function subscribeToList(parameter: SubscribeToListApiParameter) {
    return post<SubscribeToListApiParameter>(`${emailSubscriptionUrl}/SubscribeToList`, parameter);
}

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    // Store Custom Code
    // Changed the api endpoint for lead emails.
    return post<SubmitContactUsFormApiParameter, void>("/api/v1/girardin/contactus/submit", parameter);
}

export function submitNewAccountContactUsForm(parameter: SubmitNewAccountContactFormApiParameter) {
    // Store Custom Code
    // Changed the api endpoint for lead emails.
    return post<SubmitContactUsFormApiParameter, void>("/api/v1/girardin/newaccountcontact/submit", parameter);
}

export function submitPdpInfoEmail(parameter: SubmitContactUsFormApiParameter) {
    // Store Custom Code
    return post<SubmitPdpInfoFormApiParameter, void>("/api/v1/girardin/productAvailability/submit", parameter);
}
